import React from 'react';
import { Broadcast, Prohibit } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import MfaStepUpDialog from '../../components/auth/MfaStepUpDialog';

/**
 * Confirmation for the explicit 270-automation enrollment workflow.
 * `auto` is the state object returned by `useEligibilityAutomation`.
 */
export const EligibilityAutomationDialog = ({ auto, selectedCount }) => {
  const enrolling = !!auto.pending?.enrolled;
  return (
    <>
      <Dialog open={!!auto.pending} onOpenChange={(o) => { if (!o) auto.close(); }}>
        <DialogContent className="max-w-md" data-testid="eligibility-automation-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {enrolling
                ? <Broadcast size={20} className="text-emerald-700" />
                : <Prohibit size={20} className="text-amber-700" />}
              {enrolling ? 'Enable' : 'Disable'} daily 270 automation for {selectedCount} patient{selectedCount === 1 ? '' : 's'}?
            </DialogTitle>
            <DialogDescription>
              {enrolling
                ? 'Enrolled patients are included in the automated daily eligibility (270) sweep to Ohio Medicaid PRODUCTION. Imported or newly created records are never enrolled automatically — this is the only way to opt them in. Requires Agency Admin and a fresh MFA code; the change is audited.'
                : 'These patients will be removed from the automated daily eligibility (270) sweep. Their records are otherwise unchanged. Requires Agency Admin and a fresh MFA code; the change is audited.'}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-1">
            <label className="text-sm font-medium text-slate-700" htmlFor="eligibility-automation-reason">
              Reason (required)
            </label>
            <Textarea
              id="eligibility-automation-reason"
              rows={3}
              placeholder={enrolling
                ? 'e.g. Active caseload confirmed with ODM — operational go-live'
                : 'e.g. CERT test recipients — not operational members'}
              value={auto.reason}
              onChange={(e) => auto.setReason(e.target.value)}
              data-testid="eligibility-automation-reason-input"
            />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={auto.close} data-testid="eligibility-automation-cancel-btn">Cancel</Button>
            <Button
              className={enrolling ? 'bg-emerald-700 hover:bg-emerald-800' : 'bg-amber-700 hover:bg-amber-800'}
              disabled={auto.submitting || auto.reason.trim().length < 5}
              onClick={auto.submit}
              data-testid="eligibility-automation-confirm-btn"
            >
              {auto.submitting ? 'Applying…' : enrolling ? `Enable for ${selectedCount}` : `Disable for ${selectedCount}`}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <MfaStepUpDialog open={auto.stepUpOpen} onOpenChange={auto.setStepUpOpen} onVerified={auto.submit} />
    </>
  );
};

export default EligibilityAutomationDialog;
